Vue.component('User', require('./User.vue'));
Vue.component('Group', require('./Group.vue'));

Vue.component('Feature', require('./features/Feature.vue'));
Vue.component('Subfeature', require('./features/Subfeature.vue'));
Vue.component('FeatureCategory', require('./features/Category.vue'));

Vue.component('Guide', require('./guides/Guide.vue'));
Vue.component('GuideCategory', require('./guides/Category.vue'));
Vue.component('GuidePost', require('./guides/Post.vue'));

Vue.component('IntegrationTag', require('./integrations/Tag.vue'));
Vue.component('Integration', require('./integrations/Integration.vue'));

Vue.component('BlogCategory', require('./blogs/Category.vue'));
Vue.component('BlogTag', require('./blogs/Tag.vue'));
Vue.component('BlogPost', require('./blogs/Post.vue'));
Vue.component('BlogAuthor', require('./blogs/Author.vue'));

Vue.component('FormFaq', require('./FormFaq.vue'));
Vue.component('FormLinks', require('./FormLinks.vue'));

Vue.component('Ltd', require('./Ltd.vue'));

Vue.component('Template', require('./templates/Template.vue'));
Vue.component('TemplateTag', require('./templates/Tag.vue'));

Vue.component('BlogComment', require('./comments/BlogComment.vue'));

Vue.component('Page', require('./pages/Page.vue'));

Vue.component('Team', require('./Team.vue'));
Vue.component('TeamOffice', require('./TeamOffice.vue'));

Vue.component('Testimonial', require('./testimonials/Testimonial.vue'));



// WEBPACK FOOTER //
// ./resources/js/forms/bootstrap.js